import { useEffect, useState } from "react";
import "./style.css";
import logotipo from "../../../imagens/logo.svg";
import { Form, message, Modal, notification, Button } from "antd";
import { GrNext } from "react-icons/gr";
import { BsBookmarkStarFill } from "react-icons/bs";
import { PoliticaPrivacidade } from "../PoliticaPrivacidade";
import { buscarClienteReceitaFederal_MERP, Method_POST_WHATSAPP, PIX_MERP_REST, POST_MERP_REST } from "../../../service/api";
import { normalizarNome } from "../../../function/utilis/function";
import { Formulario } from "./Formulario";
import { CiShop } from "react-icons/ci";
import { toast } from "react-toastify";


export function ContratarProduto() {
    const [loadingSearchCep, setLoadingSearchCep] = useState(false);
    const steps = [
        { id: 1, title: "Dados Pessoais", description: "Completed" },
        { id: 2, title: "Dados da Empresa", description: "In Progress" },
        { id: 3, title: "Final - Pagamento", description: "Pending" },
    ];
    const [currentStep, setCurrentStep] = useState(1);
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const [isSouMEI, setIsSouMEI] = useState(true);
    const [isQueroSerMEI, setIsQueroSerMEI] = useState(false);
    const [isFlipped, setIsFlipped] = useState(false);
    const [formData, setFormData] = useState({});
    const [dadosCliente, setDadosCliente] = useState({
        cpf: "",
        cnpj: "",
        nome: "",
        email: "",
        telefone: "",
        segmento: "",
        atividade: "",
        capitalSocial: "",
        cep: "",
        logradouro: "",
        numero: "",
        complemento: "",
        bairro: "",
        cidade: "",
        ibgeMunicipio: "",
        estado: "",
    });
    const [selectFormaPagamento, setSelectFormaPagamento] = useState(null);
    const [servico, setServico] = useState("");
    const [valorServico, setValorServico] = useState("");
    const [pixBase64, setPixBase64] = useState("");
    const [qrCode, setQrCode] = useState("");
    const [valor, setValor] = useState("");
    const [isPixReady, setIsPixReady] = useState(false);
    const [api, notificacaoReendenizada] = notification.useNotification();
    const [notificacaoErro, setNotificacaoErro] = useState("");
    const [idSolicitacao, setIdSolicitacao] = useState(null);
    const [numeroCliente, setNumeroCliente] = useState(null);
    const [isNomeCliente, setNomeCliente] = useState(null);
    const [securityToken, setSecurityToken] = useState(null);
    const [municipiosOptions, setMunicipiosOptions] = useState([]);
    const [mostrarIframe, setMostrarIframe] = useState(false);
    const [linkCielo, setLinkCielo] = useState(null);
    const [loadingCheckout, setLoadingCheckout] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const abrirNotificacaoErro = (type, cpf) => {
        api[type]({
            message: `Já existe uma solicitação com esse CPF: ${cpf}`,
        });
    };

    const buscarIbgeMunicipio = async (ufSigla) => {
        const url = `ibge/municipio/listar?securityToken=${securityToken}`;

        const payload = {
            uf: { sigla: ufSigla },
        };

        try {

            const response = await POST_MERP_REST(url, payload);

            console.log("Response IBGE/MUNICIPIO", response);

            if (response && response.length > 0) {
                const options = response.map(municipio => ({
                    value: String(municipio.id),
                    label: municipio.nome
                }));
                return { options, primeiroIbgeCodigo: response[0].id };
            }
            return { options: [], primeiroIbgeCodigo: null };

        } catch (error) {
            console.error("Erro ao buscar IBGE Município:", error);
            return null;
        }
    };

    const buscarDadosCnpj = async () => {
        // 1. Valida se o CNPJ foi preenchido
        try {
            await form.validateFields(["cnpj"]);
        } catch (errorInfo) {
            message.warning("Por favor, preencha o CNPJ para buscar os dados.");
            return;
        }

        setLoadingSearchCep(true);

        try {
            // Formata o CNPJ se necessário (removendo pontos/traços)
            const cnpjFormatado = dadosCliente.cnpj.replace(/[^\d]/g, '');


            const url = `/validate?provedor=SERPRO&cnpj=${cnpjFormatado}&ordemId=${idSolicitacao}&securityToken=${securityToken}`;

            const response = await buscarClienteReceitaFederal_MERP(url);

            if (!response || response.message) {
                console.log("CNPJ não encontrado ou erro na API");
                message.error("CNPJ não encontrado ou inválido. Digite manualmente.");
                return;
            }
            if (response) {
                console.log("Mostrar dados do cnpj: ", response);

                const endereco = response.endereco || {};
                const ufSigla = endereco.uf;

                let ibgeCodigoEncontrado = null;
                const nomeMunicipioReceita = endereco.municipio?.descricao;
                let municipioNomeParaExibir = nomeMunicipioReceita; // Inicializa com o nome da Receita

                let capitalSocialString = String(response.capitalSocial || 0);
                const capitalSocialValue = parseFloat(capitalSocialString.replace('.', '').replace(',', '.')) || 0;

                if (ufSigla) {
                    const ibgeData = await buscarIbgeMunicipio(ufSigla);

                    if (ibgeData && ibgeData.options.length > 0) {
                        setMunicipiosOptions(ibgeData.options);

                        // 1. Normaliza o nome da Receita quando eu chamo pelo buscarDadosCnpj para comparação
                        const municipioReceitaFormatado = normalizarNome(nomeMunicipioReceita);

                        // 2. Busca o código IBGE correto usando a normalização
                        const municipioSelecionado = ibgeData.options.find(
                            opt => normalizarNome(opt.label) === municipioReceitaFormatado
                        );

                        if (municipioSelecionado) {
                            ibgeCodigoEncontrado = municipioSelecionado.value;
                            municipioNomeParaExibir = municipioSelecionado.label;
                        } else {
                            console.warn(`Correspondência de município falhou para: "${nomeMunicipioReceita}". Usando o primeiro município da lista.`);
                            ibgeCodigoEncontrado = ibgeData.primeiroIbgeCodigo;
                            municipioNomeParaExibir = ibgeData.options[0].label;
                        }
                    } else {
                        setMunicipiosOptions([]);
                    }
                }

                console.log("ibgeCodigoEncontrado", ibgeCodigoEncontrado);

                form.setFieldsValue({
                    // Dados da Empresa
                    razaoSocial: response.nomeEmpresarial,

                    // Endereço (usando dados da Receita)
                    cep: endereco.cep,
                    logradouro: endereco.logradouro,
                    numero: endereco.numero,
                    complemento: endereco.complemento,
                    bairro: endereco.bairro,

                    estado: endereco.uf,

                    // Preenche o Select com o CÓDIGO IBGE correto (ou fallback)
                    ibgeMunicipio: ibgeCodigoEncontrado,
                    // Preenche o campo de texto 'cidade' com o NOME padronizado
                    cidade: municipioNomeParaExibir
                });

                // Inclui TODOS os campos de endereço no seu estado `formData`
                setFormData(prev => ({
                    ...prev,
                    cep: endereco.cep,
                    cnpj: cnpjFormatado,
                    razaoSocial: response.nomeEmpresarial,
                    capitalSocial: capitalSocialValue,

                    logradouro: endereco.logradouro,
                    numero: endereco.numero,
                    complemento: endereco.complemento,
                    bairro: endereco.bairro,
                    cidade: municipioNomeParaExibir,
                    estado: endereco.uf,
                    ibgeMunicipio: ibgeCodigoEncontrado
                }));

                //Atualiza o estado local 'dadosCliente' (apenas para campos de controle)
                setDadosCliente(prev => ({
                    ...prev,
                    cep: endereco.cep,
                    cnpj: cnpjFormatado,
                }));
            }
        } catch (error) {
            console.error("Erro ao buscar cliente:", error.message);
            message.error("Erro ao buscar dados do CNPJ. Tente novamente.");
        } finally {
            setLoadingSearchCep(false);
        }
    };

    useEffect(() => {
        if (isSouMEI === true) {
            setServico("ZAP-MEI");
            setValorServico("49,90")
        }
    }, [isQueroSerMEI, isSouMEI])

    const selecionarFormaPagamento = e => {
        const selectedValue = e.target.value;
        setSelectFormaPagamento(selectedValue);
        if (selectedValue === 2) {
        gerarLinkPagamentoCartaoCredito();
        }
    }

    const handleTabChange = (type) => {
        if (type === 'SouMEI') {
            setIsSouMEI(true);
            setIsQueroSerMEI(false);
            form.resetFields();
            setCurrentStep(1);
        } else if (type === 'QueroSerMEI') {
            setIsQueroSerMEI(true);
            setIsSouMEI(false);
            form.resetFields();
            setCurrentStep(1);
        }
    };

    const onClose = () => {
        setOpen(false);
    };

    const onChange = key => {
        console.log(key);
    };

    const showDrawer = () => {
        setOpen(true);
    };

    function limparCnpj(cnpjString) {
        if (typeof cnpjString !== 'string') {
            return '';
        }
        const cnpjLimpo = cnpjString.replace(/[\.\/\-]/g, '');
        return cnpjLimpo;
    }



    {/**ENVIAR OS DADOS DO CLIENTE QUE VAI SER NO PASSO 1 */ }
    const PrimeiroCadastrar = async (contatoData) => {

        try {
            const url = `ordem-servico/vendas/cadastrar`;

            const data = {
                contato: contatoData,
                dataCriacao: new Date().toISOString(),
                dataSituacao: new Date().toISOString(),
                id: "",
                situacao: {
                    id: "I",
                },
                tipo: {
                    id: "2",
                },
            };


            console.log("payload PrimeiroCadastrar: ", data);

            const response = await POST_MERP_REST(url, data);

            if (response.erro?.id === 'BE-0001') {
                setNotificacaoErro(response.erro.mensagem);
                abrirNotificacaoErro('error', contatoData.cpf)
                return;
            }

            setIdSolicitacao(response.id);

            if(response.securityToken){
                setSecurityToken(response.securityToken);
            }

            setCurrentStep(prevStep => prevStep + 1);

        } catch (error) {
            console.error("Erro:", error.message);
        } finally {
            return;
        }
    }

    {/**ENVIAR OS DADOS DA EMPRESA QUE VAI SER NO PASSO 2 */ }
    const SegundoCadastrar = async (dadosCompletos) => {

        try {
            const url = `ordem-servico/vendas/cadastrar`;

            const contatoPayload = {
                cpf: dadosCompletos.cpf,
                nome: dadosCompletos.nome,
                email: dadosCompletos.email,
                telefone: dadosCompletos.telefone.replace(/\D/g, "")
            }

            const data = {
                contato: contatoPayload,

                dataCriacao: new Date().toISOString(),
                dataSituacao: new Date().toISOString(),

                id: String(idSolicitacao),
                securityToken: securityToken,
                situacao: {
                    id: "S",
                },
                tipo: {
                    id: "2",
                },
                empresa: {
                    cnpj: limparCnpj(dadosCompletos.cnpj),

                    segmento: { id: dadosCompletos.segmentoAtuacao || "PS" },
                    regimeTributario: { id: dadosCompletos.atividade || "SIMEI" },
                    enquadramento: { id: "MEI" },

                    nome: dadosCompletos.razaoSocial,
                    quantidadeFuncionarios: "0",
                    faturamento: dadosCompletos.capitalSocial,
                    ativa: true,
                    simplesNacional: true,

                    endereco: {
                    logradouro: dadosCompletos.logradouro,
                        numero: dadosCompletos.numero,
                        complemento: dadosCompletos.complemento,
                        bairro: dadosCompletos.bairro,

                        ibgeMunicipio: {
                            id: dadosCompletos.ibgeMunicipio,
                            nome: dadosCompletos.cidade,
                            uf: { sigla: dadosCompletos.estado },
                        },
                        cidade: dadosCompletos.cidade,
                        uf: dadosCompletos.estado,
                        cep: dadosCompletos.cep
                    },

                    qsa: []
                },
                codigoPromocional: "ZAPMEI"
            };

            //console.log("payload SegundoCadastrar: ", data);

            const response = await POST_MERP_REST(url, data);

            if (response.erro?.id === 'BE-0001') {
                setNotificacaoErro(response.erro.mensagem);
                abrirNotificacaoErro('error', dadosCompletos.cpf);
                return;
            }

            toast.success("Parabéns, sua solicitação foi resgistrada e será processada após a confirmação do pagamento!");

            const novaIdSolicitacao = response.id;
            const numeroCliente = response.contato?.telefone.replace(/\D/g, "");
            const nomeCliente = response.contato?.nome

            // 2. Atualiza o estado (assíncrono)
            setIdSolicitacao(novaIdSolicitacao);
            setNumeroCliente(numeroCliente);
            setNomeCliente(nomeCliente);

            ZapCadastro(numeroCliente, novaIdSolicitacao, nomeCliente);

            setCurrentStep(prevStep => prevStep + 1);

        } catch (error) {
            console.error("Erro:", error.message);
        } finally {
            return;
        }
    }

    const ZapCadastro = async (numeroCliente, idSolicitacao, nomeCliente) => {
        try {
            const URL = "zapmei/cadastro";

            const data = {
                cliente: { numero: "55" + numeroCliente,
                    nome: nomeCliente,
                },
                os: { 
                    id: idSolicitacao, 
                    idServico: "",
                    
                },
                
            };


            const response = await Method_POST_WHATSAPP(URL, data);

            console.log("Bateu aqui cadastro:", response);

        }catch(error){
            console.log("Erro", error);
        }finally{
            return;
        }
    }


 

    {/**CONFORME ELE SELECIONAR A OPÇÃO CARTÃO DE CRÉDITO, ELE VAI BATER NESSA API*/}
    const gerarLinkPagamentoCartaoCredito = async () => {
        setMostrarIframe(true);
        setLoadingCheckout(true);

        try {
            const url = `cielo/checkout`;
            const data = { id: idSolicitacao,  securityToken: securityToken};

            const response = await PIX_MERP_REST(url, data);
            //console.log("Resposta cartão", response.cieloCode);
            setLinkCielo(response.cieloCode);

        } catch (error) {
            console.error("Erro ao gerar PIX:", error.message);
        } finally {
            setLoadingCheckout(false);
        }
    }


    const nextStep = async () => {
        try {

            if (isQueroSerMEI) return;

            if (currentStep === 1) {
                const values = await form.validateFields(["nome", "cpf", "email", "telefone"]);

                const cpfSemMascara = values.cpf.replace(/\D/g, "");

                const contatoPayload = {
                    nome: values.nome,
                    cpf: cpfSemMascara,
                    email: values.email,
                    telefone: values.telefone.replace(/\D/g, "")
                }

                setFormData(prev => ({
                    ...prev,
                    ...values
                }));

                verificar(contatoPayload);
            } else if (currentStep === 2) {
                const camposObrigatorios = ["razaoSocial", "cnpj", "logradouro", "numero", "bairro", "cidade", "estado", "cep"];

                await form.validateFields(camposObrigatorios);

                // Pega todos os valores atuais do formulário, incluindo os preenchidos automaticamente.
                const todosOsValoresDoFormulario = form.getFieldsValue(true);

                // Combina: (1) Dados do Passo 1 + Capital Social/IBGE do formData E (2) Todos os campos do form (Passo 2)
                const dadosPasso2 = {
                    ...formData, // Garante que o CPF, Nome, Email, Telefone, Capital Social e IBGE estão presentes
                    ...todosOsValoresDoFormulario // Sobrescreve com os campos do form (Razão Social, Endereço, etc.)
                    
                }
                setFormData(dadosPasso2);
                //console.log("Dados Completos Passo 2: ", dadosPasso2);
                await SegundoCadastrar(dadosPasso2);
            }

        } catch (errorInfo) {
            if (errorInfo.errorFields) {
                message.warning("Preencha todos os campos obrigatórios antes de continuar");
            } else {
                console.error("Erro no nextStep: ", errorInfo)
            }
        }
    };

     const verificar = async (contatoData) => {
        try{

            const url = `ordem-servico/vendas/verificar`;

            const data = {
                contato: contatoData,
                dataCriacao: new Date().toISOString(),
                dataSituacao: new Date().toISOString(),
                id: "",
                situacao: {
                    id: "I",
                },
                tipo: {
                    id: "2",
                },
            };

            console.log("Tentando acessar a rota:", url);
            console.log("Payload de Verificação: ", data);

            const response = await POST_MERP_REST(url, data);
            console.log("Retorno verificado: ", response);

            if (response && response.id) {
                console.log(`Ordem de serviço existente encontrada. ID: ${response.id}. Prosseguindo para o Passo 2.`);

                setIdSolicitacao(response.id);

                if (response.securityToken) {
                    setSecurityToken(response.securityToken);
                }
                setCurrentStep(prevStep => prevStep + 1);
            }else{
                console.log("Nenhuma ordem de serviço anterior encontrada. Iniciando o cadastro (PrimeiroCadastrar).");
                PrimeiroCadastrar(contatoData);
            }
            console.log("Retorno verificado: ", response);
        }catch(error){
            console.error("Erro interno - ", error)
            return 
        }
    }

    const handleInputFocus = (fieldName) => {
        if (fieldName === 'cvv' || fieldName === 'expiry') {
            setIsFlipped(true);
        } else {
            setIsFlipped(false);
        }
    };

    const pixCheckout = async (idSolicitacao) => {
        try {
            const url = `bb/os/pix/checkout`;
            const data = { id: idSolicitacao };
            const pixData = await PIX_MERP_REST(url, data);
            console.log("pix", pixData);

            if (pixData.qrCode) {
                setPixBase64(pixData.qrCode);
                setQrCode(pixData.textoImagemQRcode);
                setValor(pixData.valor);
                console.log("QR Code Base64:", pixData);
                setIsPixReady(true);
            }
        } catch (error) {
            console.error("Erro ao gerar PIX:", error.message);
        } finally {
            return;
        }
    }

    return (
        <>
            {notificacaoReendenizada}
            <header className="header">
                <a href="https://www.meucontadoronline.com.br/">
                    <div className="logo">
                        <img src={logotipo} alt="Logo" />
                    </div>
                </a>
            </header>

            <div>
                <div className="container-banner-2">
                    <section className="banner-2">
                        <br/>
                        <div className="banner-content-2">
                            <div class="card-mobile">
                                <h2 class="plan-title">ZAP-MEI</h2>

                                <div class="plan-price">
                                    R$ <strong>49,90</strong> <span>/ mês</span>
                                </div>

                                <div class="divider"></div>

                                <ul class="plan-benefits">
                                    <li><span>✓</span> Ganhe um Certificado Digital de 12 meses</li>
                                    <li><span>✓</span> Recebimento de DAS</li>
                                    <li><span>✓</span> Emissor de NF-e</li>
                                    <li><span>✓</span> Recebimento do DAS-N</li>
                                    <li><span>✓</span> Alerta sobre estouro do faturamento MEI</li>
                                </ul>
                            </div>


                            <div className="width-85-tablet">
                                <div className="caixa-branca">
                                    <div className="stepper-progress-bar">
                                        {[1, 2, 3].map((step, index) => (
                                            <div
                                                key={step}
                                                className={`step-item ${step === currentStep
                                                    ? "in-progress"
                                                    : step < currentStep
                                                        ? "completed"
                                                        : "pending"
                                                    }`}>
                                                <div className="step-point">
                                                    {step < currentStep && <div className="step-check">✓</div>}
                                                </div>
                                                <div className="step-content">
                                                    <div className="step-number">Passo {step}</div>
                                                    <div className="step-title">
                                                        {step === 1
                                                            ? "Informações Pessoais"
                                                            : step === 2
                                                                ? "Informações da Empresa"
                                                                : "Pagamento Final"}
                                                    </div>
                                                </div>
                                                {index < steps.length - 1 && (
                                                    <div
                                                        className={`step-connector ${currentStep > step ? "completed" : ""
                                                            }`}
                                                    />
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div id="modal-cadastro-1" style={{ padding: 20 }}>
                                    <div className="tab-container">
                                        <div className={`tab-item ${isSouMEI ? "active-tab" : ""}`} onClick={() => handleTabChange('SouMEI')}>
                                            Já sou MEI
                                        </div>
                                    </div>

                                    <div className="tab-content">
                                        <Formulario
                                            form={form}
                                            currentStep={currentStep}
                                            buscarDadosCnpj={buscarDadosCnpj}
                                            loadingSearchCep={loadingSearchCep}
                                            setDadosCliente={setDadosCliente}
                                            dadosCliente={dadosCliente}
                                            selecionarFormaPagamento={selecionarFormaPagamento}
                                            selectFormaPagamento={selectFormaPagamento}
                                            qrCode={qrCode}
                                            setQrCode={setQrCode}
                                            idSolicitacao={idSolicitacao}
                                            isFlipped={isFlipped}
                                            handleInputFocus={handleInputFocus}
                                            servico={servico}
                                            valor={valor}
                                            pixCheckout={pixCheckout}
                                            isPixReady={isPixReady}
                                            setFormData={setFormData}
                                            municipiosOptions={municipiosOptions}
                                            mostrarIframe={mostrarIframe}
                                            linkCielo={linkCielo}
                                            loadingCheckout={loadingCheckout}
                                        />
                                    </div>

                                

                                    <div style={{ marginBottom: 10, color: "#afafaf" }} className="font-mob">
                                        <span>Não se preocupe, seus dados não serão utilizados para outra finalidade. Conheça nossa <a className="tag-a" onClick={showDrawer}>política de privacidade.</a></span>
                                    </div>
                                </div>

                                <div className="stepper-navigation">
                                    {currentStep < 3 ? (
                                        <button onClick={nextStep} disabled={currentStep === 3}><GrNext /></button>
                                    ) : (
                                        null
                                    )}
                                </div>
                            </div>
                        </div>

                        {/*MODAL LATERAL MOSTRANDO VALOR DO PLANO */}
                        <div class="pricing-card">
                            <div className="book-mark"><BsBookmarkStarFill /></div>
                            <div>
                                <h2 class="plan-title">{servico}</h2>
                            </div>

                            <div class="price-area">
                                <span class="current-price">R${valorServico} </span>
                                <div style={{ fontWeight: 700, position: "relative", right: 10 }}>/mês</div>
                            </div>

                            <ul class="features-list">
                                <li>
                                    <span class="check">✓</span>
                                    Ganhe um Certificado Digital de 12 meses
                                </li>
                                <li>
                                    <span class="check">✓</span>
                                    Recebimento de DAS
                                </li>
                                <li>
                                    <span class="check">✓</span>
                                    Emissor de NF-e
                                </li>
                                <li>
                                    <span class="check">✓</span>
                                    Recebimento do DAS-N
                                </li>
                                <li>
                                    <span class="check">✓</span>
                                    Alerta sobre estouro do faturamento MEI
                                </li>
                            </ul>
                        </div>
                    </section>
                </div>
            </div>
            <PoliticaPrivacidade open={open} setOpen={setOpen} onClose={onClose} onChange={onChange} />

            <Modal
                title={
                    <div style={{ display: 'flex', alignItems: 'center', color: '#00509b' }}>
                        <CiShop style={{ fontSize: '24px', marginRight: '10px' }} />
                        <span style={{ fontWeight: 600 }}>Cadastro Concluído!</span>
                    </div>
                }

                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={null}
                centered
                maskClosable={false}
            >
                <div style={{ textAlign: 'center', padding: '20px 0' }}>
                    <p style={{ fontSize: '16px', lineHeight: '1.5', marginBottom: '30px' }}>
                        <strong>Parabéns!</strong> Você agora é nosso cliente. Todo cliente ganha acesso ao nosso portal para
                        acompanhar suas ordens e a situação da sua empresa. <strong>Você receberá em instantes as credenciais de acesso ao portal no seu e-mail.</strong>
                    </p>

                    <a href="https://portal.meucontadoronline.com.br/portal/#PortalLogin" target="_blank" rel="noopener noreferrer">
                        <div
                            size="large"
                            className="btn-acessar"
                            onClick={() => setIsModalOpen(false)}
                        >
                            Acessar Portal do Cliente
                        </div>
                    </a>
                </div>
                <div style={{ textAlign: 'center', marginTop: '15px' }}>
                    <Button onClick={() => setIsModalOpen(false)}>
                        Continuar na página
                    </Button>
                </div>
            </Modal>
        </>
    );
}